module.exports = __webpack_public_path__ + "static/img/suanfa.3c6ecc7b.png";